/* Copyright (c) The New York Times Company */ import { createContext } from "react";
export const LayoutGroupContext = /*#__PURE__*/ createContext(null);
